
export const landingConfig = {
  mainNav: [
    {
      title: "功能介绍",
      href: "/",
    },
    {
      title: "AI 文献综述",
      href: "/product/literature-review",
    },
    {
      title: "AI 文献表格",
      href: "/product/literature-table",
    },
    {
      title: "产品定价",
      href: "/pricing",
    },
    {
      title: "关于我们",
      href: "/about",
    },
  ],
}
